import React, { useState, useEffect } from "react";
import "./animation.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import logo from "../website-logos/Brocon-Logo-white.svg";

const OpeningAnimation = ({ onComplete, showAnimation = true }) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  const [showLogo, setShowLogo] = useState(true);
  const [fadeOutLogo, setFadeOutLogo] = useState(false);
  const [showJobCount, setShowJobCount] = useState(false);
  const [fadeOutJobCount, setFadeOutJobCount] = useState(false);
  const [fadeOutOverlay, setFadeOutOverlay] = useState(false);

  // Prevent scroll during animation
  useEffect(() => {
    if (showAnimation) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showAnimation]);

  // 🎬 Animation timing sequence
  useEffect(() => {
    const timer1 = setTimeout(() => setFadeOutLogo(true), 4500);
    const timer2 = setTimeout(() => setShowLogo(false), 6000);
    const timer3 = setTimeout(() => setShowJobCount(true), 5000);
    const timer4 = setTimeout(() => setFadeOutJobCount(true), 9500);
    const timer5 = setTimeout(() => setShowJobCount(false), 11000);
    const timer6 = setTimeout(() => setFadeOutOverlay(true), 10500);
    const timer7 = setTimeout(() => onComplete(), 12000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
      clearTimeout(timer5);
      clearTimeout(timer6);
      clearTimeout(timer7);
    };
  }, [onComplete]);

  return (
    <div className={`overlay ${fadeOutOverlay ? "fade-out" : ""}`}>
      {showLogo && (
        <div className={`logoWrapper ${fadeOutLogo ? "fade-out" : "fade-in"}`}>
          <img src={logo} alt="Brocon Logo White" />
        </div>
      )}

      {showJobCount && (
        <div
          className={`job-count ${fadeOutJobCount ? "fade-out" : "fade-in"}`}
          ref={ref}
        >
          <div className="jobs">
            <p>
              {inView && <CountUp start={0} end={1050} duration={2} />}+<br />
              <span className="job-type">GC<br />JOBS</span>
            </p>
          </div>
          <div className="line"></div>
          <div className="jobs">
            <p>
              {inView && <CountUp start={0} end={975} duration={2} />}+<br />
              <span className="job-type">SP<br />JOBS</span>
            </p>
          </div>
          <div className="line"></div>
          <div className="jobs">
            <p>
              {inView && <CountUp start={0} end={965} duration={2} />}+<br />
              <span className="job-type">SPECIAL<br />PROJECTS</span>
            </p>
          </div>
        </div>
      )}

      {showJobCount && (
        <h2 className={fadeOutJobCount ? "fade-out" : "fade-in"}>
          Since 2015 And Counting...
        </h2>
      )}
    </div>
  );
};

export default OpeningAnimation;
